/* Sundaze reviews — star rating links + flavor-picker switching.
 *
 * - Clicking a star rating ([data-sdz-reviews-target]) opens that product's
 *   Reviews dropdown and scrolls to it. Works with <details class="sdz-rv">
 *   (sdz-reviews-panel) and the 3.5G page's .sdz-acc-item accordions.
 * - On pages with a flavor picker, each option carries
 *   data-sdz-rv-select="<group>:<key>". Clicking it shows the elements marked
 *   data-sdz-rv-group="<group>" data-sdz-rv-key="<key>" and hides the rest of
 *   that group, so the stars and Reviews dropdown follow the chosen flavor.
 */
(function () {
  /* Judge.me injects its write-review form colours as nested CSS
     (.jdgm-write-review-modal { .x { … } }). Safari before 16.5 (iPhone 7/8/X
     on iOS 15-16) ignores nested rules, so the form opened with no background
     and its text floated over the page. Where nesting is unsupported, rewrite
     those <style> tags into flat CSS. */
  var nestingSupported = (function () {
    var style = document.createElement('style');
    style.textContent = '.a{.b{color:red}}';
    document.head.appendChild(style);
    var rule = style.sheet && style.sheet.cssRules[0];
    var ok = !!(rule && rule.cssRules && rule.cssRules.length);
    style.remove();
    return ok;
  })();

  function splitSelectors(sel) {
    var out = [], depth = 0, start = 0;
    for (var i = 0; i < sel.length; i++) {
      var c = sel[i];
      if (c === '(') depth++;
      else if (c === ')') depth--;
      else if (c === ',' && depth === 0) { out.push(sel.slice(start, i).trim()); start = i + 1; }
    }
    out.push(sel.slice(start).trim());
    return out.filter(Boolean);
  }

  function joinSelectors(parents, child) {
    if (!parents) return child;
    var out = [];
    splitSelectors(parents).forEach(function (p) {
      splitSelectors(child).forEach(function (c) {
        out.push(c.indexOf('&') > -1 ? c.replace(/&/g, p) : p + ' ' + c);
      });
    });
    return out.join(', ');
  }

  function flattenCss(css) {
    css = css.replace(/\/\*[\s\S]*?\*\//g, '');
    var pos = 0;
    // Parses rules until the matching "}" and returns flat CSS for them.
    function parseBlock(selector) {
      var decls = '', nested = '', buf = '', quote = null;
      while (pos < css.length) {
        var c = css[pos++];
        if (quote) { buf += c; if (c === quote && css[pos - 2] !== '\\') quote = null; continue; }
        if (c === '"' || c === "'") { quote = c; buf += c; continue; }
        if (c === ';') { if (buf.trim()) decls += buf.trim() + ';'; buf = ''; }
        else if (c === '{') {
          var prelude = buf.trim(); buf = '';
          if (/^@(media|supports|container|layer)/.test(prelude)) {
            nested += prelude + '{' + parseBlock(selector) + '}';
          } else if (prelude.charAt(0) === '@') {
            // @keyframes, @font-face etc. are kept as written
            var depth = 1, begin = pos;
            while (pos < css.length && depth) { if (css[pos] === '{') depth++; else if (css[pos] === '}') depth--; pos++; }
            nested += prelude + '{' + css.slice(begin, pos - 1) + '}';
          } else {
            nested += parseBlock(joinSelectors(selector, prelude));
          }
        } else if (c === '}') { break; }
        else buf += c;
      }
      if (buf.trim()) decls += buf.trim() + ';';
      return (decls && selector ? selector + '{' + decls + '}' : '') + nested;
    }
    return parseBlock('');
  }

  function fixStyle(node) {
    if (node.tagName !== 'STYLE' || node.getAttribute('data-sdz-flat') === node.textContent.length + '') return;
    if (node.textContent.indexOf('jdgm') === -1) return;
    node.textContent = flattenCss(node.textContent);
    node.setAttribute('data-sdz-flat', node.textContent.length + '');
  }

  if (!nestingSupported) {
    document.querySelectorAll('style').forEach(fixStyle);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.target.tagName === 'STYLE') fixStyle(m.target);
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.tagName === 'STYLE') fixStyle(n);
          else if (n.querySelectorAll) n.querySelectorAll('style').forEach(fixStyle);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function openReviews(id, smooth) {
    var item = document.getElementById(id);
    if (!item) return false;
    if (item.tagName === 'DETAILS') {
      item.open = true;
    } else {
      var btn = item.querySelector('.sdz-acc-btn');
      if (btn && !btn.classList.contains('open')) btn.click();
    }
    item.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
    return true;
  }

  function selectFlavor(value) {
    var parts = value.split(':');
    if (parts.length !== 2) return;
    document.querySelectorAll('[data-sdz-rv-group="' + parts[0] + '"]').forEach(function (el) {
      el.hidden = el.getAttribute('data-sdz-rv-key') !== parts[1];
    });
  }

  /* Judge.me builds a single write-review form per page, bound to the first
     review widget, so on pages listing several products every review would be
     filed under the first one. Send "Write a review" to the product's own
     page instead; Judge.me opens its form there when the URL ends in #judgeme. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button, a');
    if (!btn || !/write a review/i.test(btn.textContent)) return;
    var widget = btn.closest('[data-sdz-write-url]');
    if (!widget) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = widget.getAttribute('data-sdz-write-url');
  }, true);

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-sdz-reviews-target]');
    if (link) {
      if (openReviews(link.getAttribute('data-sdz-reviews-target'), true)) e.preventDefault();
      return;
    }
    var opt = e.target.closest('[data-sdz-rv-select]');
    if (opt) selectFlavor(opt.getAttribute('data-sdz-rv-select'));
  });

  function openFromHash() {
    if (/^#sdz-reviews-/.test(location.hash)) openReviews(decodeURIComponent(location.hash.slice(1)), false);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash);
  } else {
    openFromHash();
  }
})();
